<template>
  <div class="share-trip-help-container">
    <div class="help-left">
      <div class="title_1 overflow-management">Track all of your drivers and collaborate on route planning</div>
      <div class="title_2 overflow-management">Create an account to get full visibility to your driver's location, ETA and trip updates.</div>
    </div>
    <div class="help-right">
      <div class="login">
        Already a member?
        <span @click="loginin">Log In</span>
      </div>
      <div class="start-btn" @click="startTrial">
        START FREE TRIAL
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('shareTracking', [
      'version',
      'shareId'
    ]),
  },
  methods: {
    loginin() {
      this.$root.$emit("globalMarketingTools", {
            isLogin: true,
            marketingUtm: {
            utm_source: "ShareTrip"
          },
        })
    },
    startTrial() {
      this.$buriedPoints(15, {
          Source: 'Register Banner',
          'ReadDoc AB': this.version && this.version.toLocaleUpperCase()
      })
      const href = window.location.origin + window.location.pathname + `?shareId=${this.shareId}`
      console.log(href)

      this.$root.$emit("globalMarketingTools", {
          marketingUtm: {
            utm_source: "ShareTrip"
          },
          isLogin: false,
          isExplore: false,
          isUseLocalHref: true,
        })
      //this.$root.$emit('openRegist')
    }
  }
}
</script>
<style lang="scss" scoped>
.share-trip-help-container {
  padding: 0 24px;
  position: fixed;
  top: 0;
  left: 72px;
  right: 0;
  height: 94px;
  background: #4066D4;
  z-index: 200;
  display: flex;
  align-items: center;
  .help-left {
    flex: 1;
    overflow-x: hidden;
    .title_1 {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      color: #FFFFFF;
    }
    .title_2 {
      margin-top: 2px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: rgba(255, 255, 255, 0.61);
    }
  }
  .help-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    .login {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: rgba(255, 255, 255, 0.64);
      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
    .start-btn {
      margin-left: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 137px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 22px;
      color: #4066D4;
      cursor: pointer;
    }
  }
}
</style>
